import React, { Component } from "react";
import {
  Route,
  Redirect,
} from "react-router-dom";

export const X_API_KEY = 'X-API-KEY';
export const TEST_X_API_KEY = 'TEST-X-API-KEY';

export default function PrivateRoute({ component: Component, ...rest }): Component {
  return (
    <Route
      {...rest}
      render={
        props =>
          localStorage.getItem(X_API_KEY) !== null
            ? (<Component {...props} />)
            : (<Redirect to={{ pathname: "/login", state: { from: props.location } }} />)
      }
    />
  );
}

export function isAuthenticated() {
  return localStorage.getItem(X_API_KEY) !== null;
}